import { useSelector } from "react-redux";
import React from "react";
import moment from "moment";

export function timeSince(date, t) {
  var seconds = Math.floor((new Date() - date) / 1000);
  var interval = seconds / 31536000;
  if (interval > 1) {
    return  moment(date).format("DD-MM-YYYY hh:mm A") 
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return moment(date).format("DD-MM-YYYY hh:mm A") 
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return moment(date).format("DD-MM-YYYY hh:mm A") 
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " " + t('pages.hours');
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " " + t('pages.mins');
  }
  return Math.floor(seconds) + " " + t('pages.seconds');
}

export function formatPhoneNumber(phoneNumberString) {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = match[1] ? "+1 " : "";
    return [intlCode, " ", match[2], "-", match[3], "-", match[4]].join("");
  }
  return phoneNumberString;
}

export function formatPhoneNumberturkish(phoneNumberString) {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{2})(\d{2})$/);
  if (match) {
    var intlCode = match[1] ? "+1 " : "";
    return [
      intlCode,
      " ",
      match[2],
      " ",
      match[3],
      " ",
      match[4],
      " ",
      match[5],
    ].join("");
  }
  return phoneNumberString;
}
// function formatPhoneNumberTurkish(phoneNumberString) {
//   // Remove all non-digit characters
//   const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  
//   // Initialize formatted number variable
//   let formattedNumber = '';
//   const length = cleaned.length;

//   if (length > 6) {
//     // Format the first 6 digits with a space between the first 3 and the next 3
//     formattedNumber += cleaned.substring(0, 3) + ' ' + cleaned.substring(3, 6);
//       console.log("formattedNumber ", formattedNumber, cleaned.substring(3, 6) );
//     // Process the remaining digits and format in pairs
//     const remainingDigits = cleaned.substring(6);
//     for (let i = 0; i < remainingDigits.length; i += 2) {
//       // if (i > 0) {
//         formattedNumber += ' '; // Add space between pairs
//       // }
//       formattedNumber += remainingDigits.substring(i, i + 2);
//     }
//   } else if (length > 3) {
//     // For 4 to 6 digits: format with a space after the first 3 digits
//     formattedNumber = cleaned.substring(0, 3) + ' ' + cleaned.substring(3);
//   } else {
//     // For 3 digits or fewer
//     formattedNumber = cleaned;
//   }

//   return formattedNumber;
// }
export const FindPhone = ({country_code, mobile}) =>{
  if(country_code === "+91"){
    let Number = formatPhoneNumber(mobile)
    if(!Number){
      Number = mobile
    }
    return(
      country_code + " " + Number
    )
  }else{
    let Number = formatPhoneNumberturkish(mobile)
    if(!Number){
      Number = mobile
    }
    return(
      country_code + " " + Number
    )
  }
}
export const ValidateTime = ({time}) =>{
  const language = useSelector((state)=>state?.languageState?.language)
  let value = time;
  if(language === "Tr"){
    value = time?.replace("PM", 'ÖS')
    value = value?.replace("AM", 'ÖÖ')
    value = value?.replace("pm", 'ÖS')
    value = value?.replace("am", 'ÖÖ')
  }else{
    value = time?.replace('ÖS', "PM")
    value = value?.replace('ÖÖ', "AM")
    value = value?.replace("pm", 'PM')
    value = value?.replace("am", 'AM')
  }
  return <React.Fragment>{value}</React.Fragment>
}